'use strict';

var novicell = novicell || {};

novicell.productFilters = novicell.productFilters || function () {
    
    function init() {
        openFiltersOnLoad();
        fixAccordionHeightOnClick();
        hideShowFiltersOnMobile();
    }
    function hideShowFiltersOnMobile(){
        var filterShowHideButton = document.querySelector('.o-productListFilter__mobileButton');
        if(filterShowHideButton != null){
            filterShowHideButton.addEventListener('click',function(e){
                var outer = document.getElementById('js-o-productListFilter__holder');
                var outerHeight = outer.offsetHeight;
                var innerHeight = document.getElementById('js-o-productListFilter__holderInner').offsetHeight;
                outer.style.height = innerHeight+"px";
                if(outerHeight == 0){
                    var transitionEnd = novicell.helpers.whichTransitionEvent();
                    outer.addEventListener(transitionEnd, 
                        function(){
                            if(outer.offsetHeight>0){
                                outer.style.height = "auto";
                            }
                        }, false);
                }else{
                    setTimeout(function(){outer.style.height =0;},1);
                }

            });
        }
    }
    function openFiltersOnLoad() {
        if (window.innerWidth >= 992) {
            var accordionsToShowOnLoad = document.querySelectorAll('.base-accordion--showOnLoad');
            for(var i = 0 ; i < accordionsToShowOnLoad.length ; i++){
                var elementToClick = accordionsToShowOnLoad[i].querySelector('.base-accordion__header');
                var event = document.createEvent('HTMLEvents');
                event.initEvent('click', true, false);
                elementToClick.dispatchEvent(event);
            }
        }
    }
    function fixAccordionHeightOnClick() {
        var checkboxes = document.querySelectorAll('.m-filter__checkbox');
        for(var i = 0 ; i < checkboxes.length ; i++){
            checkboxes[i].addEventListener("click", function () {
                var _this=this;
                var element = this.parentNode.querySelector('.m-filter__list--level2');
                if(element != null){
                    element.classList.remove('m-filter__list--open');
                    var baseAccordion = novicell.helpers.closestByClass(this,'base-accordion');
                    var header = baseAccordion.querySelector('.base-accordion__header');
                    if(header!=null){
                        var transitionEnd = novicell.helpers.whichTransitionEvent();
                        element.addEventListener(transitionEnd, 
                            function(){
                                novicell.accordionReadMoreOnMobile.recalcHeight(header);
                            }, false);
                    }
                }
            });
        }
    }
    
    
    
    return {
        init: init
    };
    
}();
